import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/research/opportunities')({
  beforeLoad: () => {
    throw redirect({ to: '/radar' as any })
  },
})
